module.exports = __webpack_public_path__ + "static/media/bg-arena.f4eded79.png";